<div class="homepage-header text-center">
  <h1>Huntington's Disease GWAS Data Viewer</h1>
  <p>Explore genome-wide association results across HD studies.</p>
</div>

<div class="homepage-container">
  <ngx-spinner
    color="#64748b"
    bdColor="#00000050"
    [fullScreen]="false"
    size="medium"
  >
    <div>Checking available studies...</div>
  </ngx-spinner>

  <div *ngIf="!isLoading && !error" class="studies-container">
    <h2 class="studies-title">Choose your GWAS study to explore:</h2>

    <div class="study-cards">
      <!-- GWAS 1-5 Card -->
      <div
        class="study-card brand-gem-hd"
        [class.disabled]="!grch37Available"
        (click)="navigateToGWAS15()"
      >
        <div class="card-header">
          <h3>GWAS 1-5</h3>
          <span class="study-label">Study</span>
        </div>
        <div class="card-body">
          <p class="dataset-info">Single Dataset</p>
          <p class="genome-info">(GRCh37)</p>
          <p class="doi-info">
            <a href="https://doi.org/10.1016/j.cell.2019.06.036" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()">
              10.1016/j.cell.2019.06.036
            </a>
          </p>
        </div>
        <div *ngIf="!grch37Available" class="unavailable-overlay">
          <span>Currently Unavailable</span>
        </div>
      </div>

      <!-- GWAS 1-6 Card -->
      <div class="study-card brand-gem-hd" (click)="navigateToGWAS16()">
        <div class="card-header">
          <h3>GWAS 1-6</h3>
          <span class="study-label">Study</span>
        </div>
        <div class="card-body">
          <p class="dataset-info">Multiple Datasets</p>
          <p class="genome-info">(GRCh38)</p>
          <p class="doi-info">
            <a href="https://doi.org/10.1038/s41588-025-02191-5" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()">
              10.1038/s41588-025-02191-5
            </a>
          </p>
        </div>
      </div>

      <!-- Enroll-HD WGS+ Card. Hidden behind v3Available: this study rolls out environment by
           environment, so the card must not appear where its data has not been loaded. -->
      <div
        class="study-card"
        [class.disabled]="!v3Available"
        (click)="navigateToEnrollHd()"
      >
        <div class="card-header">
          <h3>Enroll-HD WGS+</h3>
          <span class="study-label">Study</span>
        </div>
        <div class="card-body">
          <p class="dataset-info">Multiple Datasets</p>
          <p class="genome-info">(GRCh38)</p>
          <p class="doi-info">Publication pending</p>
        </div>
        <div *ngIf="!v3Available" class="unavailable-overlay">
          <span>Currently Unavailable</span>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="error" class="error-message">
    <p>Error loading studies: {{ error.status }} - {{ error.message }}</p>
    <button nbButton status="primary" (click)="checkStudyAvailability()">
      Retry
    </button>
  </div>
</div>
